"use strict";
exports.__esModule = true;
exports.LEFT_MENU_GROUP_NO_TITLE = void 0;
exports.LEFT_MENU_GROUP_NO_TITLE = 'group-no-title';
//# sourceMappingURL=container-with-left-menu-slice.js.map